import { useEffect, useRef, useState } from 'react';

export const useDocumentUploadLoader = (renderDependency: unknown) => {
  const [isDocumentUploadLoading, setIsDocumentUploadLoading] = useState(false);
  const shouldHideDocumentUploadLoaderRef = useRef(false);

  const handleDocumentUploadStart = () => {
    shouldHideDocumentUploadLoaderRef.current = false;
    setIsDocumentUploadLoading(true);
  };

  const handleDocumentUploadQueued = () => {
    shouldHideDocumentUploadLoaderRef.current = true;
  };

  const handleDocumentUploadError = () => {
    shouldHideDocumentUploadLoaderRef.current = false;
    setIsDocumentUploadLoading(false);
  };

  useEffect(() => {
    if (!shouldHideDocumentUploadLoaderRef.current) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      shouldHideDocumentUploadLoaderRef.current = false;
      setIsDocumentUploadLoading(false);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [renderDependency]);

  return {
    isDocumentUploadLoading,
    handleDocumentUploadStart,
    handleDocumentUploadQueued,
    handleDocumentUploadError,
  };
};
